import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showBackdrop: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setShowBackdrop: (state, action) => {
      state.showBackdrop = action.payload;
    },
  },
});

export const { setShowBackdrop } = uiSlice.actions;

export default uiSlice.reducer;

export const selectShowBackdrop = (state) => state.ui.showBackdrop;
